let CartPage = (function () {

    function handleLinkedProductRemoval() {

        // Nasłuchuj kliknięć na przyciski usuwania w koszyku
        document.addEventListener('click', async function(e) {
            const removeLink = e.target.closest('a.cart__items__remove');

            if (removeLink) {


                if (removeLink.dataset.clicked === 'true') {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }

                removeLink.dataset.clicked = 'true';
                removeLink.classList.add('is-disabled');

                e.preventDefault();



                const href = removeLink.getAttribute('href');
                const lineKey = href.match(/line=(\d+)/)?.[1];


                if (lineKey) {
                    await removeLinkedProduct(parseInt(lineKey));
                }
            }
        });


    }

    async function removeLinkedProduct(lineKey) {
        try {
            let response = await fetch('/cart.js');
            let cart = await response.json();
            const itemToRemove = cart.items[lineKey - 1];

            if (!itemToRemove) return;

            const linkedGroup = itemToRemove.properties?._linked_group;

            // Zbierz wszystkie klucze produktów do usunięcia
            const keysToRemove = [];//@todo old_version (do usunięcia po testach): [itemToRemove.key];

            if (linkedGroup) {
                cart.items.forEach(item => {
                    if (item.properties?._linked_group === linkedGroup && item.key !== itemToRemove.key) {
                        keysToRemove.push(item.key);
                    }
                });
            }


            const form = document.querySelector('form[action="/cart"]'); // dostosuj jeśli masz inny selector

            cart.items.forEach((item, index) => {
                if (keysToRemove.includes(item.key)) {
                    const input = form.querySelector(`[data-update-cart="${item.key}"]`);
                    if (input) {
                        input.value = 0;
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            return;

            //@todo old_version (do usunięcia po testach)

            // Usuń wszystkie produkty po kluczu wariantu
            for (const key of keysToRemove) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: key, quantity: 0 })
                });
            }

            //window.location.reload();
            
            document.dispatchEvent(new CustomEvent('theme:cart:reload', {
                bubbles: true,

            }));

            response = await fetch('/cart.js');
            cart = await response.json();

            document.dispatchEvent(new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: {
                    cart: cart
                }
            }));

        } catch (error) {
            console.error('Błąd przy usuwaniu:', error);
        }
    }

    function updateHeaderCartCount(count) {

        console.log("updateHeaderCartCount " + count)
        var newCount = count || 0;

        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = newCount;
            el.dataset.cartCount = newCount;
        });
    }

    function initInvoiceForm()
    {
        let targetInput = document.getElementById('invoice_form_trigger');
        let form = document.getElementById('invoice_form');

        let invoice_form_trigger_event_type = 'click';

        targetInput.addEventListener(invoice_form_trigger_event_type, function() {
            if(targetInput.checked)
                Custom.showElement(form);
            else
                Custom.hideElement(form);

        });

        Custom.dispatchEvent(targetInput, invoice_form_trigger_event_type);

    }

    function initAcceptTerms()
    {
        const agreeCheckbox = document.getElementById("personal_data_processing_consent");
        const acceptTerms = agreeCheckbox.parentNode;

        const errorMsg = document.querySelector(".accept_terms_error");
        const cartForm = document.querySelector("form[action='/cart']");
        const checkoutBtn = document.querySelector("[name='checkout']");

        let personal_data_processing_consent_event_type = 'change';

        // Ukrywanie błędu po kliknięciu checkboxa
        agreeCheckbox.addEventListener(personal_data_processing_consent_event_type, () => {
            if (agreeCheckbox.checked) {
                errorMsg.style.display = "none";
            }
        });

        // Obsługa wysyłki formularza koszyka
        if (cartForm) {
            cartForm.addEventListener("submit", function(e) {
                if (!agreeCheckbox.checked) {
                    e.preventDefault();
                    errorMsg.style.display = "block";
                    acceptTerms.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        }

        // Dodatkowo blokada przycisku "Przejdź do kasy"
        if (checkoutBtn) {
            checkoutBtn.addEventListener("click", function(e) {
                if (!agreeCheckbox.checked) {
                    e.preventDefault();
                    errorMsg.style.display = "block";

                    acceptTerms.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            });
        }

        Custom.dispatchEvent(agreeCheckbox, personal_data_processing_consent_event_type);
    }

    function init()
    {
        handleLinkedProductRemoval();
        initInvoiceForm();
        initAcceptTerms();
    }

    document.addEventListener('DOMContentLoaded', function() {
        init();
    });

    return {

    }

})();